import React, { useState, useEffect } from 'react';
import Apiconnect from "../services/Apiconnect.js";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { IoMdCloudOutline } from "react-icons/io";
import { MdOutlineDelete } from "react-icons/md";
import { IoDocumentTextOutline } from "react-icons/io5";
import { FaRegEye } from "react-icons/fa";


const Document = () => {
  const [file, setFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [userId, setUserId] = useState('');
  const [custId, setCustId] = useState('');
  const [documents, setDocuments] = useState([]);

  useEffect(() => {
    const userIdFromStorage = localStorage.getItem("userId");
    const custIdFromStorage = localStorage.getItem("custId");
    if (userIdFromStorage && custIdFromStorage) {
      setCustId(custIdFromStorage);
      setUserId(userIdFromStorage);
      fetchDocuments(custIdFromStorage);
    }
    console.log("Customer ID:", custIdFromStorage);
  }, []);

  // Function to fetch documents from the API
  const fetchDocuments = async (custId) => {
    try {

      const response = await Apiconnect.getData("cust_files");

      if (response.data && response.data.status === "success") {
        // Filter documents by matching custId
        const userDocuments = response.data.data.filter(
          doc => doc.cust_id.toString() === custId.toString()
        );
        console.log("User documents:", userDocuments);
        setDocuments(userDocuments);
      } else {
        toast.error("Failed to fetch documents");
      }
    } catch (error) {
      console.error("Error fetching documents:", error);
      toast.error("Error fetching documents. Please try again later.");
    } finally {

    }
  };

  const handleFileUpload = async (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      await uploadFile(selectedFile);
    }
  };

  const uploadFile = async (selectedFile) => {
    setIsLoading(true);

    const formData = new FormData();
    formData.append('file', selectedFile);
    formData.append('cust_id', userId);

    try {
      // First API call to upload the file
      const response = await Apiconnect.postDataNoauth("upload3", formData);
      console.log("Upload response:", response.data);

      if (response.data.status === 'success') {
        toast.success('File Uploaded Successfully');


        const recentFileName = response.data.recent_file_name[0];
        const recentFileUrl = response.data.recent_file_url[0];
        const recentFolderName = response.data.folder_name;

        const indata = {
          "cust_id": custId,
          "file_name": recentFileName,
          "folder_name": recentFolderName,
          "file_path": recentFileUrl
        };

        console.log("Sending file metadata:", indata);

        const documentsResponse = await Apiconnect.postDataNoauth('cust_file', indata);
        console.log("Document storage response:", documentsResponse.data);

        fetchDocuments(custId);
      } else {
        toast.error(response.data.message || 'Upload failed');
      }
    } catch (error) {
      const err = error?.response?.data?.message || 'Something went wrong during upload!';
      console.error("API Error:", error);
      toast.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const deleteFile = async (id, file_name, folder_name) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this document? By clicking Yes, this will be deleted.");
    if (!confirmDelete) return;

    const inputData = {
      "filename": file_name,
      "cust_id": folder_name
    }

    try {
      const response = await Apiconnect.postDataNoauth("delete", inputData);
      if (response.data.status === 'success') {
        const response = await Apiconnect.deleteData(`cust_file/${id}`);
        if (response.data.status === 'success') {
          toast.success("File Deleted Successfully");
          fetchDocuments(id);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }


  return (
    <div className="container-fluid ">
      <div className="card mb-4 shadow-sm">
        <div className="card-body">
          <h5 className="card-title mb-3">Upload Documents</h5>
          <div>
            <button
              className="btn btn-primary d-flex align-items-center mb-3"
              onClick={() => document.getElementById('fileInput').click()}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  UPLOADING...
                </>
              ) : (
                <>
                  <IoMdCloudOutline size={20} className='me-2' />
                  UPLOAD FILES
                </>
              )}
            </button>
            <input
              id="fileInput"
              type="file"
              className="d-none"
              onChange={handleFileUpload}
              disabled={isLoading}
            />
            <p className="text-muted small">Supported formats: PDF</p>
          </div>
        </div>
      </div>

      {/* Stored Documents Section */}
      <div className="card shadow-sm mb-5">
        <div className="card-header bg-light">
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Stored Documents</h5>
            {isLoading && (
              <div className="spinner-border spinner-border-sm text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            )}
          </div>
        </div>
        <div className="card-body">
          {documents.length > 0 ? (
            <div className="list-group">
              {documents.map((doc, index) => (
                <div key={index} className="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">

                    <div>
                      <h6 className="mb-0">{doc.file_name}</h6>
                      <small className="text-muted">Uploaded on {new Date(doc.created_on).toLocaleDateString()}</small>
                    </div>
                  </div>
                  <div className="d-flex gap-3">
                    <FaRegEye
                      size={18}
                      className="text-primary cursor-pointer"
                      onClick={() => window.open(doc.file_path, '_blank')}
                      title="View Document"
                      style={{ cursor: 'pointer' }}
                    />
                    <MdOutlineDelete
                      size={18}
                      className="text-danger cursor-pointer"
                      onClick={() => deleteFile(doc.id, doc.file_name, doc.folder_name)}
                      title="Delete Document"
                      style={{ cursor: 'pointer' }}
                    />
                  </div>


                </div>
              ))}
            </div>
          ) : (
            <div className="text-center text-muted py-5">
              <IoDocumentTextOutline size={20} />
              <p className="mb-0">No documents uploaded yet</p>
              <p className="small text-muted">Upload your first document to get started</p>
            </div>
          )}
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Document;